/**
 * @file コンポーネント：共通フッター スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { clipPathHidden, mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledFooter = styled.footer`
    padding-bottom: 4px;
    background-color: #ffffff;
`;

export const StyledFooterBottomContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: 20px;

    ${mediaQuery.sp(`
        max-width: 344px;
    `)};

    ${mediaQuery.spWide(`
        max-width: 448px;
    `)};

    ${mediaQuery.tablet(`
        display: flex;
        justify-content: space-between;
        max-width: 712px;
    `)};

    ${mediaQuery.pc(`
        display: flex;
        justify-content: space-between;
        max-width: 712px;
    `)};

    ${mediaQuery.pcWide(`
        display: flex;
        justify-content: space-between;
        max-width: 1160px;
    `)};
`;

export const StyledFooterBottomSection = styled.section`
    position: relative;
    flex-basis: 100%;
    margin-bottom: 4px;

    &:last-of-type {
        margin-bottom: 0;
    }

    ${mediaQuery.tablet(`
        flex-basis: calc(50% - 24px);
        margin-bottom: 0;
    `)};

    ${mediaQuery.pc(`
        flex-basis: calc(50% - 24px);
        margin-bottom: 0;
    `)};

    ${mediaQuery.pcWide(`
        flex-basis: calc(50% - 24px);
        margin-bottom: 0;
    `)};
`;

export const StyledFooterBottomGeoLite2Text = styled.p`
    position: absolute;
    left: 0;
    bottom: 0;
    margin-bottom: 0;
    font-size: 12px;
    color: #666666;

    & > a {
        font-size: 12px;
    }
`;

export const StyledFooterContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: 16px;

    ${mediaQuery.sp(`
        max-width: 344px;
    `)};

    ${mediaQuery.spWide(`
        max-width: 448px;
    `)};

    ${mediaQuery.tablet(`
        max-width: 712px;
    `)};

    ${mediaQuery.pc(`
        max-width: 712px;
        display: flex;
        flex-direction: column;  /* 縦並びに変更（PCでも縦並び） */
    `)};

    ${mediaQuery.pcWide(`
        max-width: 1160px;
        display: flex;
        flex-direction: column; /* 縦並びに変更 */
    `)};
`;

export const StyledFooterCopyright = styled.small`
    display: block;
    margin: 0 auto;
    color: #000000;
    font-size: 13px;
    line-height: 1.5;
    text-align: right;
`;

export const StyledFooterHeadline = styled.h2`
    ${clipPathHidden};
`;

export const StyledFooterLogo = styled.p`
    margin: 0 auto 15px;
    text-align: right;

    ${mediaQuery.sp(`
        padding-top: 12px;
        text-align: center;
    `)};

    ${mediaQuery.spWide(`
        padding-top: 12px;
        text-align: center;
    `)};

    ${mediaQuery.tablet(`
        padding-top: 12px;
        text-align: center;
    `)};
`;

export const StyledFooterLogoImage = styled.img``;

export const StyledFooterLogoText = styled.span`
    margin-right: 24px;
    color: #000000;
    font-size: 15px;
`;

export const StyledFooterSection = styled.section`
    flex-basis: 100%;
    margin-bottom: 4px;

    ${mediaQuery.pcWide(`
        display: flex;
        flex-direction: column;
        gap: 8px; /* 行間を調整 */
    `)};
`;

export const StyledFooterSectionAnchor = styled.a`
    color: #666666;
    font-size: 14px;
    line-height: 20px;
`;

export const StyledFooterSectionFull = styled(StyledFooterSection)`
    ${mediaQuery.pcWide(`
        flex-basis: 100%;
        margin-right: 0;
    `)};

    ${mediaQuery.sp(`
        padding-bottom: 12px;
    `)};

    ${mediaQuery.spWide(`
        padding-bottom: 12px;
    `)};

    ${mediaQuery.tablet(`
        padding-bottom: 12px;
    `)};
`;

export const StyledFooterSectionHeadline = styled.h3`
    margin-bottom: 1px;
    color: #212121;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
`;

export const StyledFooterSectionHeadlineBorder = styled(
    StyledFooterSectionHeadline
)`
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #000000;

    ${mediaQuery.pcWide(`
        width: 100%; /* 横幅を広げる */
    `)};
`;

export const StyledFooterSectionList = styled.ul`
    ${mediaQuery.pc(`
        display: flex;
        gap: 16px; /* 横並び間隔 */
        flex-direction: row; /* 横並び */
    `)};

    ${mediaQuery.pcWide(`
        display: flex;
        gap: 16px; /* 横並び間隔 */
        flex-direction: row; /* 横並び */
    `)};
`;

export const StyledFooterSectionListItem = styled.li`
    margin-bottom: 4px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledFooterUnderlineText = styled.span`
    text-decoration: underline;
`;
